import { useGtm } from '@gtm-support/vue-gtm'

let gtm = null

let rewriteCurrencyRate = 1
let rewriteCurrency = null

const getGtm = () => {
    if (gtm === null) {
        gtm = useGtm()
    }

    return gtm
}

export const setCurrency = (currency, rate) => {
    console.log('GTM set currency', {currency, rate})
    rewriteCurrency = currency
    rewriteCurrencyRate = rate
}

const errorHandler = (originalFunction) => {
    return (...args) => {
        try {
            return originalFunction(...args)
        } catch (error) {
            console.error(error.message, args)
            return
        }
    }
}

export const createDeepClone = (product) => JSON.parse(JSON.stringify(product))

export function parseBreadcrumbsIntoListName (titleData) {
    return titleData.reduce((a, b) => (a.title || a) + " / " + b.title)
}

const removeNullProps = (eventData) => {
    return Object.keys(eventData)
        .filter((key) => eventData[key] != null)
        .reduce((a, key) => ({ ...a, [key]: eventData[key] }), {})
}

const resetDataLayer = () => {
    window.dataLayer.push(function() {
        this.reset()
    })
}

let populateGtmItemFromOrder = null
let populateGtmItemFromProduct = null

export const setGtmItemMapCallback = (type, callback) => {
    if (type === 'order') {
        populateGtmItemFromOrder = callback
    } else if (type === 'product') {
        populateGtmItemFromProduct = callback
    }
}

export const createGtmItemFromOrder = errorHandler((product, item_list_name, item_list_id) => {
    if (!populateGtmItemFromOrder) {
        throw new Error("Project specific method for populating gtm item from order not defined.")
    }

    return removeNullProps({
        ...populateGtmItemFromOrder(product),
        item_list_id,
        item_list_name,
    })
})

export const createGtmItemFromProduct = errorHandler((product, item_list_name, item_list_id) => {
    if (!populateGtmItemFromProduct) {
        throw new Error("Project specific method for populating gtm item from order not defined.")
    }  

    return removeNullProps({
        ...populateGtmItemFromProduct(product),
        item_list_id,
        item_list_name,
    })
})

export const mapGtmItemsFromOrder = (products, item_list_name, item_list_id) => {
    return products
        .map(product => createGtmItemFromOrder(product, item_list_name, item_list_id))
        .filter(product => product !== null)
}

export const mapGtmItemsFromProducts = (products, item_list_name, item_list_id) => {
    return products
        .map(product => createGtmItemFromProduct(product, item_list_name, item_list_id))
        .filter(product => product !== null)
}

export const trackECommerceEvent = errorHandler((items, currency, value, event) => {
    if (!event || !currency || !value || !items || items.length < 1) {
        throw new Error("Invalid ecommerce data, can't track gtm eCommerceEvent")
    }

    const eventData = {
        event,
        ecommerce: removeNullProps({
            currency: rewriteCurrency ? rewriteCurrency : currency,
            value: typeof value === 'number' ? value * rewriteCurrencyRate : value,
            items
        })
    }

    resetDataLayer()
    getGtm().trackEvent(eventData)
})

export const trackAddPaymentInfo = errorHandler((items, currency, value, payment_type, coupon) => {
    if (!currency || !value || !items || items.length < 1) {
        throw new Error("Invalid payment data, can't track gtm add_payment_info")
    }

    const eventData = {
        event: 'add_payment_info',
        ecommerce: removeNullProps({
            currency: rewriteCurrency ? rewriteCurrency : currency,
            value: typeof value === 'number' ? value * rewriteCurrencyRate : value,
            coupon,
            payment_type,
            items
        })
    }

    resetDataLayer()
    getGtm().trackEvent(eventData)
})

export const trackAddShippingInfo = errorHandler((items, currency, value, shipping_tier, coupon) => {
    if (!currency || !value || !items || items.length < 1) {
        throw new Error("Invalid shipping data, can't track gtm add_shipping_info")
    }

    const eventData = {
        event: 'add_shipping_info',
        ecommerce: removeNullProps({
            currency: rewriteCurrency ? rewriteCurrency : currency,
            value: typeof value === 'number' ? value * rewriteCurrencyRate : value,
            coupon,
            shipping_tier,
            items
        })
    }

    resetDataLayer()
    getGtm().trackEvent(eventData)
})

export const trackPurchase = errorHandler((items, currency, value, transaction_id, shipping, tax, coupon) => {
    if (!currency || !transaction_id || !value || !items || items.length < 1) {
        throw new Error("Invalid purchase data, can't track gtm purchase")
    }

    const eventData = {
        event: 'purchase',
        ecommerce: removeNullProps({
            currency: rewriteCurrency ? rewriteCurrency : currency,
            transaction_id,
            value: typeof value === 'number' ? value * rewriteCurrencyRate : value,
            coupon,
            shipping,
            tax,
            items
        })
    }

    resetDataLayer()
    getGtm().trackEvent(eventData)
})

export const trackViewItem = errorHandler((item, currency, value) => {
    if (!item) {
        throw new Error("Invalid product data, can't track gtm view_item")
    }

    const eventData = {
        event: 'view_item',
        ecommerce: removeNullProps({
            currency: rewriteCurrency ? rewriteCurrency : currency,
            value: typeof value === 'number' ? value * rewriteCurrencyRate : value,
            items: [item]
        })
    }

    resetDataLayer()
    getGtm().trackEvent(eventData)
})

export const trackViewItemList = errorHandler((items, item_list_name, item_list_id) => {
    if (!items || items.length < 1) {
        throw new Error("Invalid products data, can't track gtm view_item_list")
    }

    const eventData = {
        event: 'view_item_list',
        ecommerce: removeNullProps({
            item_list_id,
            item_list_name,
            items
        })
    }

    resetDataLayer()
    getGtm().trackEvent(eventData)
})
